module.exports = __webpack_public_path__ + "8ba7f6bc59a42ac7dd2fc69f63da5eb2.svg";